import { Col, Container, Row } from "react-bootstrap";
import Nft5Img from '../assets/img/5.jpg';
import "./Layout.scss";
import LogoImg from '../assets/img/logo-footer.png';
import solanaImg from '../assets/img/solana.png';
import discordSvg from '../assets/img/discord.svg';
import twitterSvg from '../assets/img/twitter.svg';
import magicedenPng from '../assets/img/magiceden.png';
function AppFooter() {
    return <section id="appFooter" className="p-5">
        <Container>
            <Row>
                <Col className="text-left">
                    <img src={LogoImg} className="logo"/>
                </Col>
                
                <Col className="d-flex justify-content-end mobile-center">
                    <a href="https://discord.gg/qrWAD67Y7N" target="_blank" className="p-2">
                        <img src={discordSvg} className="footer-icon" />
                    </a>
                    <a href="https://twitter.com/solporate" target="_blank" className="p-2">
                        <img src={twitterSvg} className="footer-icon" />
                    </a>
                    <a href="https://magiceden.io/" target="_blank" className="p-2">
                        <img src={magicedenPng} className="footer-icon" />
                    </a>                    
                </Col>
            </Row>
            <hr />
            <Row>
                <Col>
                    <img src={solanaImg} className="footer-img" />
                    <p className="p-3">Built on Solana</p>
                </Col>
            </Row>
        </Container>
    </section>
}

export default AppFooter;